"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var stateMapper = require("./uwp-player-state-mapper");
var UWP_ERROR_CODES = {
    INVALID_AVAILABLE_AUDIO_TRACKS: 'UWP-AUD-1',
    INVALID_CURRENT_AUDIO_TRACKS: 'UWP-AUD-2',
    DEFAULT_AUDIO_LANGUAGE_ARRAY_NOT_SUPPORTED: 'UWP-AUD-3',
};
var UWPPlayer = (function (_super) {
    __extends(UWPPlayer, _super);
    function UWPPlayer(window, messengerService, mediaRemoteService) {
        var _this = _super.call(this) || this;
        _this.messengerService = messengerService;
        _this.mediaRemoteService = mediaRemoteService;
        _this.window = window;
        return _this;
    }
    UWPPlayer.prototype.initialise = function () {
        var _this = this;
        this.messengerService.registerCommand('bitrate', function (event) {
            _this.notifyBitrateChanged({ bitrateKbps: event.data.bitrate });
        });
        this.messengerService.registerCommand('position', function (event) {
            _this.notifyCurrentPositionChanged(event.data.elapsedTime);
            _this.notifyDurationChanged(event.data.totalTime);
        });
        this.messengerService.registerCommand('state', function (event) {
            if (event.data.state === 'error') {
                var uwpError = event.data.additionalInfo || {};
                _this.raiseErrorAndStop({
                    isFatal: uwpError.isFatal !== false,
                    message: uwpError.details || 'unknown-error',
                    code: uwpError.code || '',
                });
                return;
            }
            var state = stateMapper.getPlayerState(event.data.state);
            if (state !== undefined) {
                _this.notifyStateChange(state);
            }
        });
        this.messengerService.registerCommand('availableAudioTracks', function (event) {
            var availableNativeAudioTracks = event && event.data && event.data.availableAudioTracks;
            if (!Array.isArray(availableNativeAudioTracks)) {
                _this.notifyWarning(UWP_ERROR_CODES.INVALID_AVAILABLE_AUDIO_TRACKS, "Available audio tracks event triggered with invalid data: " + JSON.stringify(event && event.data));
                return;
            }
            var commonAudioTracks = availableNativeAudioTracks.map(function (nativeAudioTrack) { return ({
                language: nativeAudioTrack.language,
                trackId: nativeAudioTrack.name,
            }); });
            _this.notifyAvailableAudioTracksChanged(commonAudioTracks);
            if (_this.defaultAudioLanguage) {
                var defaultNativeAudioTrack = commonAudioTracks.find(function (audioTrack) { return audioTrack.language === _this.defaultAudioLanguage; });
                if (defaultNativeAudioTrack) {
                    _this.nativeSetAudioTrack(defaultNativeAudioTrack.trackId);
                }
                else if (commonAudioTracks.length) {
                    _this.nativeSetAudioTrack(commonAudioTracks[0].trackId);
                }
            }
        });
        this.messengerService.registerCommand('currentAudioTrack', function (event) {
            var currentAudioTrack = event && event.data && event.data.currentAudioTrack;
            if (currentAudioTrack) {
                _this.notifyCurrentAudioTrackChanged(currentAudioTrack.name);
            }
            else {
                _this.notifyWarning(UWP_ERROR_CODES.INVALID_CURRENT_AUDIO_TRACKS, "Current audio track changed event triggered with invalid track: " + JSON.stringify(event && event.data));
            }
        });
        return Promise.resolve();
    };
    UWPPlayer.prototype.nativeLoad = function (nativeLoadData) {
        var message = {
            command: 'load',
            contentUrl: nativeLoadData.cdn.url,
        };
        if (Array.isArray(nativeLoadData.defaultAudioLanguage)) {
            this.notifyWarning(UWP_ERROR_CODES.DEFAULT_AUDIO_LANGUAGE_ARRAY_NOT_SUPPORTED, 'Setting defaultAudioLanguage with an array is not supported on this device.');
        }
        else {
            this.defaultAudioLanguage = nativeLoadData.defaultAudioLanguage;
        }
        if (nativeLoadData.position) {
            message.time = nativeLoadData.position;
        }
        if (nativeLoadData.drmConfiguration) {
            message.licenseUrl = nativeLoadData.drmConfiguration.licenceAcquisitionUrl;
            message.challengeCustomData = nativeLoadData.drmConfiguration.customChallengeData;
        }
        this.setPlayoutRect(nativeLoadData.custom && nativeLoadData.custom.playoutRect);
        this.messengerService.sendMessage(message);
        this.notifyStateChange(client_lib_js_player_addons_common_player_1.PlayerState.Loading);
        this.mediaRemoteService.setStatusPlaying();
    };
    UWPPlayer.prototype.nativePlay = function () {
        this.messengerService.sendMessage({
            command: 'play',
        });
        this.mediaRemoteService.setStatusPlaying();
    };
    UWPPlayer.prototype.nativePause = function () {
        this.messengerService.sendMessage({
            command: 'pause',
        });
        this.mediaRemoteService.setStatusPaused();
    };
    UWPPlayer.prototype.initiateSeek = function (timeSeconds) {
        var message = {
            command: 'skipTo',
            position: timeSeconds,
        };
        this.messengerService.sendMessage(message);
    };
    UWPPlayer.prototype.nativeStop = function () {
        this.messengerService.sendMessage({
            command: 'stop',
        });
        this.mediaRemoteService.setStatusStopped();
    };
    UWPPlayer.prototype.dispose = function () {
        return Promise.resolve();
    };
    UWPPlayer.prototype.getFullScreenPlayoutRect = function () {
        return {
            x: 0,
            y: 0,
            width: this.window.innerWidth,
            height: this.window.innerHeight,
        };
    };
    UWPPlayer.prototype.setPlayoutRect = function (playoutRect) {
        var fullScreenRect = this.getFullScreenPlayoutRect();
        var rect = playoutRect || fullScreenRect;
        var message = {
            command: 'setPlayerStyle',
            data: {
                width: (rect.width || fullScreenRect.width) + "px",
                height: (rect.height || fullScreenRect.height) + "px",
                top: (rect.y || fullScreenRect.y) + "px",
                left: (rect.x || fullScreenRect.x) + "px",
            },
        };
        this.messengerService.sendMessage(message);
    };
    UWPPlayer.prototype.nativeSetVolume = function (volume) {
        this.messengerService.sendMessage({
            command: 'setVolume',
            volume: volume,
        });
    };
    UWPPlayer.prototype.nativeSetMute = function (isMute) {
        this.messengerService.sendMessage({
            command: 'setMute',
            isMute: isMute,
        });
    };
    UWPPlayer.prototype.nativeSetAudioTrack = function (audioTrackId) {
        this.messengerService.sendMessage({
            command: 'setAudioTrack',
            audioTrackId: audioTrackId,
        });
    };
    return UWPPlayer;
}(client_lib_js_player_addons_common_player_1.Player));
exports.UWPPlayer = UWPPlayer;
